import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface removeSpotlightInterface {
  vid: string;
}

export const useRemoveSpotlightVideos = () => {
  const mutate = useMutation(({ vid }: removeSpotlightInterface) => {
    return get(`/enterprise-media-api/remove_spotlight_videos/${vid}`);
  });

  return mutate;
};

export default useRemoveSpotlightVideos;
